import { DocumentRagServiceClient } from "@formant/core/client/DocumentRagServiceClient";
import { IDocumentSet } from "@formant/core/model/documents/IDocumentSet";
import { HasId } from "@formant/core/model/HasId";
import { IWorkflowWebRagResponse } from "@formant/core/model/IWorkflowWebRagResponse";

import { IAuthStore } from "./IAuthStore";

export class DocumentSetStore {
    constructor(
        private documentRagServiceClient: DocumentRagServiceClient,
        private authStore: IAuthStore,
    ) {}

    async queryDocumentSets(
        question: string,
        documentSets: string[],
    ): Promise<IWorkflowWebRagResponse> {
        return this.documentRagServiceClient.queryDocumentSets(
            await this.authStore.token(),
            question,
            documentSets,
        );
    }

    async getDocumentSets(): Promise<HasId<IDocumentSet>[]> {
        return await this.documentRagServiceClient.getDocumentSets(
            await this.authStore.token(),
        );
    }
}
